import type { UserDTO } from '@copilot/shared';

/**
 * In-memory session store. The access token is deliberately NOT persisted
 * (no localStorage); a page reload restores the session via the httpOnly
 * refresh-token cookie (see `refreshSession` in api/client.ts).
 */
export interface Session {
  accessToken: string;
  user: UserDTO;
}

type Listener = () => void;

let current: Session | null = null;
const listeners = new Set<Listener>();

export const sessionStore = {
  get(): Session | null {
    return current;
  },
  set(next: Session | null): void {
    current = next;
    for (const l of listeners) l();
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
